import React, { useState, useEffect, useCallback, useMemo, useRef } from 'react';
import { Typography, Divider, Paper, Grid, Box, Stack, Tooltip, IconButton, Button, Dialog, DialogActions, DialogTitle, DialogContent, TextField
} from '@mui/material';
import { useSnackbar } from 'notistack';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import ReactDataGrid from '@inovua/reactdatagrid-community'
import useConfirm from 'core/hooks/useConfirm';
import '@inovua/reactdatagrid-community/index.css'
import { getAmenities, saveAmenity, deleteAmenity } from 'services/amenities';


const AmenetiesPage = () => {

  const gridStyle = useMemo(() => ({ minHeight: 480, width: 422 }), []);
  const [amenityList, setAmenityList] = useState([]);
  const [openModal, setOpenModal] = useState(false);
  const { enqueueSnackbar } = useSnackbar();
  const confirm = useConfirm();
  const amenityInputRef = useRef(null);

  const onActionBtnClick = useCallback((e, type, amenityName) => {
    e.preventDefault();
    if(type === 'delete'){
      onAmenityDelete(amenityName);
    }
  }, []);

  const columns = useMemo(() => ([
    { name: 'name', header: 'Amenity', width: 300},
    { name: 'actions', header: 'Actions', width: 120, render: ({data}) => {
      return (
        <Stack direction="row" spacing={1}>
          <Box>
            <Tooltip title="Delete Amenity" arrow placement="left">
              <IconButton onClick={(e) => onActionBtnClick(e, 'delete', data?.name)}>
                <DeleteForeverIcon color="error" />
              </IconButton>
            </Tooltip>
          </Box>
        </Stack>
      )
    }},
  ]),[onActionBtnClick]);

  useEffect(() => {
    getAmenityList();
  }, []);

  function getAmenityList() {
    getAmenities().then(({response, error}) => {
      if(response){
        setAmenityList([...(response || [])].map((ele) => ({name: ele})));
      } else {
        setAmenityList([]);
        enqueueSnackbar((response?.message || error), {variant: 'error'});
      }
    });
  }

  const onAmenityDelete = (amenityName) => {
    confirm({ title: 'Delete Amenity?', description: 'Are you sure you want proceed?' })
    .then(() => { 
      _deleteAmenity(amenityName);
    }).catch((e)=>{})
  }

  const onModalClose = useCallback(
    () => {
      setOpenModal(false);
    },
    [setOpenModal],
  )

  const onSaveAmenityBtnClick = (amenity) => {
    if(amenity){
      addAmenity(amenity);
    }else{
      enqueueSnackbar("Enter amenity name", {variant: 'error'});
    }
  };

  const onAddAmenityBtnClick = () => {
    setOpenModal(true);
  }

  const onAmenityAdded = () => {
    setOpenModal(false);
    getAmenityList();
  }

  function addAmenity(amenity) {
    saveAmenity({amenity}).then(({response, error}) => {
      if(response){
        enqueueSnackbar((response?.message || 'Amenity added successfully'), {variant: 'success'});
        amenityInputRef.current.value = '';
        onAmenityAdded();
      } else {
        enqueueSnackbar((response?.message || error), {variant: 'error'});
      }
    });
  }

  function _deleteAmenity(amenity) {
    deleteAmenity({amenity}).then(({response, error}) => {
      if(response){
        enqueueSnackbar((response?.message || 'Amenity deleted successfully'), {variant: 'success'});
        getAmenityList();
      } else {
        enqueueSnackbar((response?.message || error), {variant: 'error'});
      }
    });
  }

  return (
    <Paper sx={{ minWidth: 275, py: 2, px: 3, minHeight: "calc(100vh - 100px )" }}>
    {/* <CardContent> */}
      <Typography component="h2" variant="h6" color="secondary" gutterBottom sx={{mb: 1}}>
        Amenities
      </Typography>
      <Divider />
      <Box noValidate  sx={{ mt: 2 }} >
        <Grid container spacing={3}>
          <Grid item xs={12} sm={12} md={12} lg={12} >
            <Button variant="contained" sx={{textTransform: 'none'}} onClick={onAddAmenityBtnClick}>Add Amenity</Button>
            <Box component="div" sx={{  mt: 3 ,  maxHeight: 720, width: '100%' }}>
              <ReactDataGrid
                // handle={setGridRef}
                // idProperty="index"
                style={gridStyle}
                // defaultFilterValue={filterValue}
                columns={columns}
                dataSource={amenityList}
                rowHeight={null} 
                minRowHeight={50}
              />
            </Box>
          </Grid>
        </Grid>
      </Box> 
      
      <Dialog open={openModal} onClose={onModalClose}>
        <DialogTitle>Add Amenity </DialogTitle>
        <DialogContent>
          <TextField
            autoFocus
            margin="dense"
            id="name"
            label="Name"
            type="text"
            fullWidth
            variant="standard"
            sx={{width: '320px'}}
            inputRef={amenityInputRef}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={onModalClose}>Cancel</Button>
          <Button onClick={() => onSaveAmenityBtnClick(amenityInputRef.current.value)}>Save</Button>
        </DialogActions>
      </Dialog>

    </Paper>
  );
}
 
export default React.memo(AmenetiesPage);
